/* eslint-disable global-require, import/no-dynamic-require */
export const { API_BASE_URL, APP_URL, AUTHENTICATION_URL, SALESFORCE_URL, FIREBASE_SERVICE_ACCOUNT } = require(`./${process.env.REACT_APP_ENV}/api`)
export const READ_ONLY_MODE = process.env.REACT_APP_READ_ONLY_MODE === 'true'

// export const API_BASE_URL = 'http://api-crc.flerken/v1/'
// export const APP_URL = 'http://client-web-crc.flerken'
// export const AUTHENTICATION_URL = 'https://auth.grpcom.com.br/auth/dev-api-crc?next=client-web-crc.flerken'

/* eslint-enable global-require */